import React, {Component} from 'react';

//import Highcharts from 'highcharts/highstock'

import {injectIntl} from 'react-intl';
import Helpable from '../Helpable';

const Highcharts = window.Highcharts;


class MapsChart extends Component {

  constructor(props) {
      super(props);
      ////console.log("NEW-MAP-CHART");
      this.renderChart=this.renderChart.bind(this);
      this.print=this.print.bind(this);
      //this.handleResize=this.handleResize.bind(this);
      this.getChart=this.getChart.bind(this);

      this.state = {
        print:false,
        windowWidth: window.innerWidth
      }
    }

  getChart() {
    return this.chart;
  }

  renderChart(container, type, options) {
    //console.log("renderChart");
    this.chart = new Highcharts[type || "Chart"](
      container,
      options
    );

    //console.log("RENDER-CHART-> Rendered: "+container+ " Type: "+ type+ " options "+options);
  }

  // Implmentazione della print
  print() {
    //console.log("REAL PRINT");

    this.chart.print();
  }

  highchartsModules() {
    if (this.props.modules) {
      this.props.modules.forEach(function(module) {
        module(Highcharts);
      });
    }
  }

  componentDidMount() {
    //window.addEventListener('resize', this.handleResize);
    this.highchartsModules();

    this.renderChart(this.props.container,this.props.type, this.props.options);

  }

  componentWillUnmount() {
    //window.removeEventListener('resize', this.handleResize);
    this.chart.destroy();
  }

  render() {
    ////console.log("Render() MapsChart");

    return (
      <Helpable bind={this.props.container} guideRef="generic.chart.guide">
      <div  className={this.props.className}  ref="outerMapRef" style={this.props.style} id={this.props.container}></div>
    </Helpable>
  );
  }
}

export  default injectIntl(MapsChart, {withRef: true});



// WEBPACK FOOTER //
// ./src/components/charts/MapsChart.js